import { Trade } from './types';

const isTopPosition = (trade: Trade) => {
  return (trade.size || 1) >= (trade.openInterest || 0);
};

export default isTopPosition;
